import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/neoderma.webp';
import screenshot_target from '../../../images/letterfunnel/andreasloizou.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Andreas Loizou"
      firstname="Andreas"
      companyname="NEODERMA"
      competition="Dermalogica en IMAGE Skincare"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/andreasloizou.js